<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                        Bandeja Compliant
                    </v-col>

                   <v-col cols="12" sm="12" md="6">
                        <!--<v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNueva"
                        >
                            Crear nueva
                        </v-btn>-->
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
                
                <v-row class="col-md-12 d-none">
                        
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="12" md="6">
                        
                        <v-text-field
                        append-icon="search"
                        label="Buscar"
                        outlined
                        autocomplete="off"
                        dense
                        hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :items-per-page="10"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.nombre }}</td>
                            <td>{{ item.tipoSocio }}</td>   
                            
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estado_Socios_Id == 2 ? 'teal' : 'gray'"
                                        text-color="white"
                                        small
                                    >
                                        {{item.estadoSocio}}
                                    </v-chip>
                            </td>
                            <!-- <td>{{ item.tipoSocio }}</td>-->
                            <td>
                                <!--<v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>

                                <v-btn class="ma-2" small tile outlined color="indigo" @click="mostrarModalDocumentos(item.nombre_Completo, item.tipoSocio_Id, item.subTipoSocio_Id, item.id)">
                                    <v-icon left>mdi-file-document-outline</v-icon> Documentos
                                </v-btn>

                                -->
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="mostrarProspecto(item.id, item.tipo_Socios_Id)">
                                    <v-icon left>mdi-clipboard-text-outline</v-icon> Ver prospecto
                                </v-btn>
                                


                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>

            
        </v-card>


         <!--Dialog loader -->
        <dialog-loader
            :dialogVisible="dialogLoaderVisible"
            :text="dialogLoaderText"
        ></dialog-loader>
        <!---->


        <SnackAlert  ref="snackalert"></SnackAlert>

        <SubHeader></SubHeader>

        <!-- Inicio:: Dialog para mostrar los datos del prospecto -->
        <v-dialog
            v-model="dialogDatosProspecto"
            fullscreen 
            persistent 
            transition="dialog-bottom-transition"
            
        >
        
        <v-card scrollable>
            <v-card-title>
                {{titleDialogDatos}}
                <v-spacer></v-spacer>
                <v-btn
                    icon

                    @click="dialogDatosProspecto = false"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <!-- Inicio:: Mostrar los datos del prospecto -->
                <component v-bind:is="actualVistaProspecto" :datos="datosInstitucion" :contactos="contactos" :documentosLegales="documentosLegales">
                <!-- component changes when vm.currentView changes! -->
                </component>
                <!-- Fin:: Mostrar los datos del prospecto -->
            </v-card-text>
            <v-card-actions class="p-10">
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            :disabled="btnRegistroLoading"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogDatosProspecto=false"
                        >
                            Cerrar
                        </v-btn>
                        <v-btn
                            color="error"
                            elevation="0"
                            :disabled="btnRegistroLoading"
                            class="mb-2 float-right error"
                            @click="mostrarModalEstado(4)"
                        >
                            Rechazar Prospecto
                        </v-btn>
                        <v-btn
                            color="success"
                            class="mb-2 success float-right"
                            
                            :elevation="0"
                            :loading="btnRegistroLoading"
                            
                            @click="mostrarModalEstado(3)"
                        >
                            Aceptar Prospecto
                        </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
        <!-- Fin:: Dialog para mostrar los datos del prospecto -->



    <!-- Inicio:: Dialog para el cambio de estado al prospecto (aceptado o rechazado)-->
    <v-dialog
        v-model="dialogConfirmarEstado"
        max-width="400px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                Confirmar
                
                <v-spacer></v-spacer>
                <v-btn
                    icon

                    @click="dialogConfirmarEstado = false"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                    ref="docForm"
                    v-on:submit.prevent="cambiarEstado"
                    >
            <v-card-text>
                <v-container>
                    <h3>{{dialogConfirmarEstadoText}}</h3>
                </v-container>
            </v-card-text>
            <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            :disabled="btnConfirmarEstadoLoading"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogConfirmarEstado = false"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0"
                            :loading="btnConfirmarEstadoLoading"                           
                        >
                            {{btnConfirmarEstadoText}}
                        </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    

    <!-- Fin:: Dialog para el cambio de estado al prospecto (aceptado o rechazado)-->

       
    </div>
</template>
<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DialogLoader from "@/view/content/DialogLoader";

import SnackAlert from '@/view/content/SnackAlert.vue';
import SubHeader from "@/view/components/subheader/SubHeader";

import DatosProspectoInstitucion from "@/view/components/prospectos/DatosProspectoInstitucion";
import DatosProspectoEmpresa from "@/view/components/prospectos/DatosProspectoEmpresa";
import DatosProspectoSocioExtranjero from "@/view/components/prospectos/DatosProspectoSocioExtranjero";

import { OBTENER_COMPLIANT_ITEMS } from "@/core/services/store/compliant.module";
import { OBTENER_INSTITUCION_DESCRIPCIONES } from "@/core/services/store/institucion.module";
import { OBTENER_SOCIO_EXTRANJERO_DESCRIPCIONES } from "@/core/services/store/socioextranjero.module";
import { OBTENER_EMPRESA_DESCRIPCIONES } from "@/core/services/store/empresa.module";

import { OBTENER_CONTACTOS_INSTITUCION} from "@/core/services/store/contacto.module";
import { OBTENER_CONTACTOS_SOCIO_EXTRANJERO} from "@/core/services/store/contacto.module";
import {OBTENER_CONTACTOS_EMPRESA} from "@/core/services/store/contacto.module";

import {OBTENER_DOCUMENTOS_POR_EMPRESA_INSTITUCION} from "@/core/services/store/cargaarchivo.module";
import {ACTUALIZAR_ESTADO_ITEM} from "@/core/services/store/estadoitem.module";


export default {
    name: "admin-compliant",
    components: {
        "dialog-loader": DialogLoader,
        SnackAlert,
        SubHeader,
        DatosProspectoInstitucion,
        DatosProspectoEmpresa,
        DatosProspectoSocioExtranjero,
        
    },
    data(){
        return{
            tableLoading:false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo información',
            dialogDatosProspecto:false,
            dialogConfirmarEstado: false,
            titleDialogDatos:'',
            btnRegistroLoading:false,
            btnConfirmarEstadoLoading: false,
            dialogConfirmarEstadoText:'',
            btnConfirmarEstadoText:'',
            items: [],
            ran:0,
            actualVistaProspecto: 'DatosProspectoSocioExtranjero',
            datosInstitucion: {
                id:0,
                direccion:null,
                nombre_Completo:null,
                siglas:null,
                oficina_CEO_Id:0,
                oficinaCeo: '',
                pais_Id:1,
                pais:'',
                departamentos_Id: 0,
                depto: '',
                municipios_Id: null,
                municipio:'',
                subTipo_Socios_Id:0,
                telefono:null,
                tipo_Socios_Id:0,
                tipoSocio:'',
                subTipoSocio: '',
                estados_Id:1,
                estado: '',
                
                estado_Socios_Id: 1,
                usuarios_Id: 1,
                usuario:'',

            },
            contactos:[],
            documentosLegales: [],
            estadoNuevo:0,
            prospectoId:0,
            tipoSocioId: 0
        }
    },
    methods:{
        obtenerItems(){
            this.items=[];
            this.tableLoading=true;

            this.$store
            .dispatch(OBTENER_COMPLIANT_ITEMS, 2)
            .then(() => {
                this.items = this.$store.state.compliant.compliantItems;
                //console.log(this.items)
                //console.log(this.items)
                //console.log(this.items)
                this.tableLoading=false;
            })
            .catch(() => {
                this.tableLoading=false;
            });   
        },


        /**
         * !Mostrar la información completa del prospecto segun su id y el tipo de socio que sea (Empresa, Socio Extranjero o Institucion)
         * 1. institucion
         * 2. extranjero
         * 3. empresa
         */
        
        mostrarProspecto(prospectoId, tipoSociosId){
            this.prospectoId=prospectoId;
            this.tipoSocioId=tipoSociosId;
            this.ran = Math.floor(Math.random() * (10 - 1 + 1)) + 1;

            //?Si es intitución obtener los datos con el servicio de institucion
            if(tipoSociosId===1){
                this.dialogLoaderVisible=true;
                this.$store
                .dispatch(OBTENER_INSTITUCION_DESCRIPCIONES, prospectoId)
                .then(res => {
                    console.log(res)
                    if(res.status===200){

                        let item = this.$store.state.institucion.institucion;

                        this.titleDialogDatos="Datos de la institución";
                        this.datosInstitucion=item;

                        this.actualVistaProspecto='DatosProspectoInstitucion';
                        this.obtenerContactosInstitucion(item.id);
                        this.cargarDocumentosProspecto(1, item.id);
                        this.dialogDatosProspecto=true;

                    } else{
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'No se ha podido completar la solicitud.');
                    }
                    this.dialogLoaderVisible=false;
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                });
            }
            //?Si es socio extranjero obtener los datos con el servicio de socio extranjero
            else if(tipoSociosId===2){

                this.dialogLoaderVisible=true;
                this.$store
                .dispatch(OBTENER_SOCIO_EXTRANJERO_DESCRIPCIONES, prospectoId)
                .then(res => {
                    if(res.status===200){
                        this.titleDialogDatos="Datos del Socio Extranjero";
                        let item = this.$store.state.socioextranjero.socioExtranjero;
                        this.datosInstitucion=item;
                        this.obtenerContactosSocio(item.id);
                        this.cargarDocumentosProspecto(2, item.id);
                        this.actualVistaProspecto='DatosProspectoSocioExtranjero';
                        this.dialogLoaderVisible=false;
                        this.dialogDatosProspecto=true;
                    } else{
                        this.dialogLoaderVisible=false;
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'No se ha podido completar la solicitud.');
                    }
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                });
                
            }
            //?Si es empresa obtener los datos con el servicio de empresa
            else if(tipoSociosId===3){
                 this.dialogLoaderVisible=true;
                this.$store
                .dispatch(OBTENER_EMPRESA_DESCRIPCIONES, prospectoId)
                .then(res => {
                    if(res.status===200){
                        this.titleDialogDatos="Datos de la Empresa";
                        let item = this.$store.state.empresa.empresa;
                        this.datosInstitucion=item;
                        this.obtenerContactosEmpresa(item.id);
                        this.cargarDocumentosProspecto(3, item.id);
                        this.actualVistaProspecto='DatosProspectoEmpresa';
                        this.dialogLoaderVisible=false;
                        this.dialogDatosProspecto=true;
                    } else{
                        this.dialogLoaderVisible=false;
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'No se ha podido completar la solicitud.');
                    }
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                });
                
            }

            console.log(prospectoId + " " + tipoSociosId)
        },


        //!Obtener los contactos segun el prospecto seleccionado
        obtenerContactosInstitucion(prospectoId){
            this.contactos=[];
            this.$store
                    .dispatch(OBTENER_CONTACTOS_INSTITUCION, {estadoId: 1, empresaId: prospectoId})
                    .then(res => {
                        //console.log(res);
                        if(res.status===200){
                            this.contactos = res.data;
                            //console.log(this.contactos)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error al realizar la solicitud.');
                    });
            
        },

        //!Obtener los contactos segun el prospecto seleccionado
        obtenerContactosSocio(empresaId){
            this.contactos=[];
            this.$store
                    .dispatch(OBTENER_CONTACTOS_SOCIO_EXTRANJERO, {estadoId: 1, empresaId: empresaId})
                    .then(res => {
                        //console.log(res);
                        if(res.status===200){
                            this.contactos = res.data;
                            //console.log(this.contactos)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error al realizar la solicitud.');
                    });
            
        },

        //!Obtener los contactos segun el prospecto seleccionado
        obtenerContactosEmpresa(empresaId){
            this.contactos=[];
            this.$store
                    .dispatch(OBTENER_CONTACTOS_EMPRESA, {estadoId: 1, empresaId: empresaId})
                    .then(res => {
                        //console.log(res);
                        if(res.status===200){
                            this.contactos = res.data;
                            //console.log(this.contactos)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error al realizar la solicitud.');
                    });
            
        },


        

        //!Obtener los documentos por prospecto
        cargarDocumentosProspecto(tipo, prospectoId){

            let institucionEstadoId = 0;
            let socioExtranjeroId = 0;
            let empresaId = 0;

            if(tipo===1){
                institucionEstadoId= prospectoId;
            }
            if(tipo===2){
                socioExtranjeroId= prospectoId;
            }
            if(tipo===3){
                empresaId= prospectoId;
            }

            this.documentosLegales=[];
            
            //!Obtener los documentos legales de la empresa seleccionada
            this.$store
            .dispatch(OBTENER_DOCUMENTOS_POR_EMPRESA_INSTITUCION, {estadoId: 1, socioExtranjeroId: socioExtranjeroId, institucionEstadoId: institucionEstadoId, empresaId: empresaId})
            .then(res2 => {
                //console.log(res2)
                if(res2.status===200){
                    this.documentosLegales = res2.data;
                }
            })
            .catch(() => {});
            
        },

        
        /**
         * !Mostrar modal para el cambio de estado
         * 3 Coautorizado, 4 corechazado
         */
        mostrarModalEstado(nuevoEstado, tipoSociosId){
            this.estadoNuevo = nuevoEstado;
            this.itemTipo = tipoSociosId;
            if(nuevoEstado==3){
                this.dialogConfirmarEstadoText = 'Está seguro de autorizar el prospecto seleccionado?';
                this.btnConfirmarEstadoText='Autorizar';
            }
            if(nuevoEstado==4){
                this.dialogConfirmarEstadoText = 'Está seguro de rechazar el prospecto seleccionado?';
                this.btnConfirmarEstadoText='Rechazar';
            }

            this.dialogConfirmarEstado=true;
        },

        //!Cambiar el estado al prospecto (Aceptado / rechazado)
        cambiarEstado(){
            this.btnConfirmarEstadoLoading=true;
            let datosItem = {
                tipo_Socios_Id: this.tipoSocioId,
                estado_Socios_Id: this.estadoNuevo
            }
            this.$store
            .dispatch(ACTUALIZAR_ESTADO_ITEM, {id: this.prospectoId, datosItem: datosItem})
            .then(res => {
                console.log(res);
                if(res.status===200){
                    this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.mensaje);
                    //this.restablecerCampos();
                    //this.obtenerContactos(this.empresaId);
                    this.obtenerItems();
                    this.dialogConfirmarEstado=false;
                    this.btnConfirmarEstadoLoading=false;
                    this.dialogConfirmarEstado=false;
                    this.dialogDatosProspecto=false;
                } else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.mensaje);
                }
                this.btnConfirmarEstadoLoading=false;
            })
            .catch(err => {
                console.log(err)
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error al realizar la solicitud.');
                this.btnConfirmarEstadoLoading=false;
            });
        },


        aceptarProspecto(){

        },

        rechazarProspecto(){

        }
    },
    created(){
        this.obtenerItems();
    },
    mounted(){
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Compliant" }
        ]);
    },
     computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre del Prospecto",
                    value: "nombre"
                },
                {
                    text: "Tipo de Socio",
                    value: "tipoSocio"
                },
                {
                    text: "Estado",
                    value: "estados_Socio_Id"
                }/*,
                {
                    text: "Fecha de Ingreso",
                    value: "tipoSocio"
                }*/,
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        },
     }
}
</script>
<style lang="">
    
</style>